export class AsyncUtility {
  static async sleep(ms: number) {
    return new Promise(resolve => setTimeout(resolve, ms));
  }

  static async wait(isCompleted: () => boolean, pollingIntervalAsMsec: number = 100) {
    while (!isCompleted()) {
      await AsyncUtility.sleep(pollingIntervalAsMsec);
    }
  }
}
